import createRequest from 'utils/request';
import type { Period } from 'utils/types';

export enum ResponsibleGamingType {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

type LimitType = {
  type: ResponsibleGamingType;
  value?: number;
  dateFrom?: number;
  dateTo?: number;
  future?: LimitType;
};

type ResponsibleGamingResponse = LimitType[];

export const getDepositLimitsRequest = createRequest<
  ResponsibleGamingResponse,
  never
>('/api/client/client:get-deposit-limits', {
  headers: {
    'Content-Type': 'application/json',
  },
});

type RealityCheckPayload = {
  period: Period;
};

type RealityCheckRequest = {
  body: RealityCheckPayload;
};

export const getRealityCheckSettingsRequest = createRequest<
  RealityCheckPayload,
  never
>('/api/client/reality-check:get-reality-check-settings', {
  headers: {
    'Content-Type': 'application/json',
  },
});

export const setRealityCheckSettingsRequest = createRequest<
  never,
  RealityCheckRequest
>('/api/client/reality-check:set-reality-check-settings', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
});

type SelfExclusionRequest = {
  body: {
    days: number;
  };
};

type SelfExclusionResponse = {
  days: number;
  selfExcludedDueDate: number;
};

export const getSelfExclusionSettingsRequest = createRequest<
  SelfExclusionResponse,
  never
>('/api/client/client:get-self-exclusion-settings', {
  headers: {
    'Content-Type': 'application/json',
  },
});

export const setSelfExclusionSettingsRequest = createRequest<
  SelfExclusionResponse,
  SelfExclusionRequest
>('/api/client/v2/client:set-self-exclusion-settings', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const realityCheckPingRequest = createRequest<string, never>(
  '/api/client/reality-check:ping',
  {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  },
);
